import { RolesPermissionType } from './roles-permissions.state';

const mockRoleValues: RolesPermissionType = {
    role: 'ROLE_ABCIS',
    authorities: [
        'CREATE_AUDIT',
        'DELETE_AUDIT',
        'READ_AUDIT',
        'UPDATE_AUDIT',
        'CREATE_HOST',
        'DELETE_HOST',
        'READ_HOST',
        'UPDATE_HOST',
        'CREATE_INVITATION',
        'DELETE_INVITATION',
        'READ_INVITATION',
        'UPDATE_INVITATION',
        'CREATE_INVOICE',
        'DELETE_INVOICE',
        'READ_INVOICE',
        'UPDATE_INVOICE',
        'CREATE_ORGANISATION',
        'DELETE_ORGANISATION',
        'READ_ORGANISATION',
        'UPDATE_ORGANISATION',
        'CREATE_PRODUCT',
        'DELETE_PRODUCT',
        'READ_PRODUCT',
        'UPDATE_PRODUCT',
        'CREATE_PURCHASE ORDER',
        'DELETE_PURCHASE ORDER',
        'READ_PURCHASE ORDER',
        'UPDATE_PURCHASE ORDER',
        'CREATE_REPORT',
        'DELETE_REPORT',
        'READ_REPORT',
        'UPDATE_REPORT',
        'CREATE_SCAN DATA',
        'DELETE_SCAN DATA',
        'READ_SCAN DATA',
        'UPDATE_SCAN DATA',
        'CREATE_USER',
        'DELETE_USER',
        'READ_USER',
        'UPDATE_USER'
    ]
};

export default mockRoleValues;